module.exports = __webpack_public_path__ + "img/sijucai.05209574.jpg";